import { useCallback, useState } from "react";

export const useTrigger = (initialValue = 0) => {
  const [trigger, setTrigger] = useState(initialValue);

  const triggerNext = useCallback(() => {
    setTrigger((prev) => prev + 1);
  }, []);

  return [trigger, triggerNext] as const;
};
